module.exports = __webpack_public_path__ + "img/brand-profile.a8d75043.svg";